export default "__VITE_ASSET__CN$FigtC__"